export default __webpack_public_path__ + "static/media/mainHeading.fca4754d.png";